export default __webpack_public_path__ + "static/media/shop_pinpoint.ad259cf4.svg";